import actionTypes from "../action-types";
import { LocationType } from "../models/state/locations/location/Location";

export const receiveLocations = (locations: Array<LocationType>) => {
  return {
    type: actionTypes.ADD_LOCATIONS,
    payload: {
      locations
    }
  };
};
